type Props = {
  className?: string;
  fill?: string;
  height?: string;
  width?: string;
};

const ArrowIcon = ({
  className,
  height = '20',
  fill = 'black',
  width = '20'
}: Props) => {
  return (
    <svg
      className={className}
      height={height}
      width={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.64645 7.64645C2.45118 7.84171 2.45118 8.15829 2.64645 8.35355L5.82843 11.5355C6.02369 11.7308 6.34027 11.7308 6.53553 11.5355C6.7308 11.3403 6.7308 11.0237 6.53553 10.8284L3.70711 8L6.53553 5.17157C6.7308 4.97631 6.7308 4.65973 6.53553 4.46447C6.34027 4.2692 6.02369 4.2692 5.82843 4.46447L2.64645 7.64645ZM3 8.5L13 8.5L13 7.5L3 7.5L3 8.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default ArrowIcon;
